var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0"},[_c('base-subheading',[_vm._v("Tags")]),_vm._l((_vm.categories),function(category,i){return _c('v-chip',{key:i,staticClass:"mr-2",attrs:{"color":"secondary","label":"","small":"","tag":"","text-color":"white"}},[_vm._v(" "+_vm._s(category.text)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }